module.exports = __webpack_public_path__ + "static/media/facebookLogo.10607ca9.png";